if (document.body.classList.contains("home")) {
    const links = document.querySelectorAll(".news__innerRows .News");

    let currentIndex = 0;

    // 指定されたインデックスのニュースアイテムを表示
    const showItem = (index) => {
        links.forEach((item, i) => {
            item.classList.remove("is-on");
            item.classList.remove("is-off");
            if (i === index) {
                item.classList.add("is-on");
            }
            if (i === (index - 1 < 0 ? links.length - 1 : index - 1)) {
                item.classList.add("is-off");
            }
        });
    };

    const interFunc = () => {
        showItem(currentIndex);
        currentIndex = (currentIndex + 1) % links.length;
    };
    interFunc();

    const resize = () => {
        let maxheight = 0;
        links.forEach((link, i) => {
            const height = link.getBoundingClientRect().height;
            maxheight = Math.max(maxheight, height);
        });

        document.querySelector(
            ".news__innerRows"
        ).style.height = `${maxheight}px`;
    };

    resize();
    let resizeTimeout;

    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            resize();
        }, 500);
    });

    // 5秒ごとにニュースアイテムを切り替え
    inter = setInterval(interFunc, 5450);
}
